import httpClient from '../../../shared/services/httpClient';

const profileApi = {
  // Get current user profile
  getProfile: async () => {
    try {
      const response = await httpClient.get('/auth/me');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update profile information
  updateProfile: async (profileData) => {
    try {
      const response = await httpClient.put('/auth/profile', profileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Change password
  changePassword: async (passwordData) => {
    try {
      const response = await httpClient.post('/users/change-password', passwordData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Upload profile picture
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    
    try {
      const response = await httpClient.post('/users/avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Remove profile picture
  removeAvatar: async () => {
    try {
      const response = await httpClient.delete('/users/avatar');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default profileApi;